import { ADMIN_MESSAGE_API } from "../../../constants/api";
import axiosHttp from "../../interceptors/axios-interceptor";

export default function GetActiveAdminMessage(listType){
    const api = `${ADMIN_MESSAGE_API}ordinary/is-active/${listType}/`;
    return axiosHttp.get(api);
}